var _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationExpectedPickupNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9866 8.31879C38.1874 11.8326 35.3581 14.7243 31.8179 14.7243C28.5994 14.7243 25.9348 12.3123 25.6591 9.21016H23.9726C23.3735 9.21016 22.8877 8.73521 22.8877 8.1498C22.8877 7.56412 23.3735 7.08944 23.9726 7.08944H25.6356V5.18107C25.6356 3.42762 27.0959 2 28.8894 2H34.7466C36.5401 2 38.0004 3.42789 38.0004 5.18107C38.0004 5.98186 37.9866 7.53126 37.9866 8.31879ZM27.8413 9.21016C28.1076 11.1384 29.7975 12.6033 31.8182 12.6033C33.8385 12.6033 35.5284 11.1384 35.7948 9.21016H27.8413ZM34.7466 4.12072H28.8894C28.2935 4.12072 27.8048 4.59843 27.8048 5.18107V7.08944H35.8312V5.18107C35.8312 4.59843 35.3426 4.12072 34.7466 4.12072Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.7143,
    cy: 26.7143,
    r: 7.71429,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8509 21.2861C11.505 21.2861 12.0352 21.8163 12.0352 22.4704V27.3019C12.0352 27.9559 11.505 28.4861 10.8509 28.4861C10.1969 28.4861 9.6667 27.9559 9.6667 27.3019V22.4704C9.6667 21.8163 10.1969 21.2861 10.8509 21.2861ZM10.8509 29.8861C11.505 29.8861 12.0352 30.4163 12.0352 31.0704V31.1019C12.0352 31.7559 11.505 32.2861 10.8509 32.2861C10.1969 32.2861 9.6667 31.7559 9.6667 31.1019V31.0704C9.6667 30.4163 10.1969 29.8861 10.8509 29.8861Z",
    fill: "#F47A36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34.5V23.3828C37 22.4766 36.7635 21.5862 36.3139 20.7994V20.7994C35.4883 19.3545 34.0218 18.3913 32.3679 18.2075L32.2952 18.1995C31.1307 18.0701 29.9559 18.3265 28.9512 18.9293L28.6681 19.0991C28.2244 19.3654 27.815 19.685 27.4491 20.0509L22.5858 24.9142C22.2107 25.2893 21.702 25.5 21.1716 25.5H20.5M31 23L24.0763 29.4621C23.706 29.8078 23.2183 30 22.7117 30H20.5M26.5 34V27.5",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.1111V15C13 14.4477 13.4477 14 14 14H20C20.5523 14 21 14.4477 21 15V21.1111C21 21.602 20.602 22 20.1111 22V22H19.2222",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15L17 14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationExpectedPickupNegative);
export default __webpack_public_path__ + "static/media/notification-expected-pickup-negative.92a795b938e8a86920d1b978a0488d37.svg";
export { ForwardRef as ReactComponent };